import { registerComponent } from '@gig/magic-common';
import ConditionalComponent from './conditional.vue.js';

var Conditional = registerComponent(ConditionalComponent);

export { Conditional };
